import { render } from "./PayCallBack.vue?vue&type=template&id=3a610308"
import script from "./PayCallBack.vue?vue&type=script&lang=js"
export * from "./PayCallBack.vue?vue&type=script&lang=js"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__